import { Routes } from '@angular/router';
import { permissionGuard } from './shared/guards/permission.guard';
import { purchaseOrderCreateGuard } from './shared/guards/purchase-order-create.guard';

export const routes: Routes = [
  {
    path: '', 
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Iniciar sesión'
    }
  },
  {
    path: 'login', 
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Iniciar sesión'
    }
  },
  {
    path: 'nueva-venta',
    loadComponent: () => import('./sale-create-update/sale-create-update.component').then(m => m.SaleCreateUpdateComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Venta',
      requiredPath: '/nueva-venta'
    }
  },
  {
    path: 'modificar-venta/:id', 
    loadComponent: () => import('./sale-create-update/sale-create-update.component').then(m => m.SaleCreateUpdateComponent),
    data: {
      title: 'Venta'
    }
  },
  {
    path: 'listar-ventas',
    loadComponent: () => import('./sale-list/sale-list.component').then(m => m.SaleListComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Lista de ventas',
      requiredPath: '/listar-ventas'
    }
  },
  {
    path: 'listar-cajas',
    loadComponent: () => import('./cash-list/component/cash-list.component').then(m => m.CashListComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Lista de cajas',
      requiredPath: '/listar-cajas'
    }
  },
  {
    path: 'listar-envios',
    loadComponent: () => import('./shipment-list/shipment-list.component').then(m => m.ShipmentListComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Lista de envios',
      requiredPath: '/listar-envios'
    }
  },
  {
    path: 'ordenes-compra',
    loadComponent: () =>
      import('./purchase-order/purchase-order-list/purchase-order-list.component').then(
        m => m.PurchaseOrderListComponent
      ),
    canActivate: [permissionGuard],
    data: {
      title: 'Órdenes de compra',
      requiredPath: '/ordenes-compra'
    }
  },
  {
    path: 'ordenes-compra/nueva',
    loadComponent: () =>
      import('./purchase-order/purchase-order-form/purchase-order-form.component').then(
        m => m.PurchaseOrderFormComponent
      ),
    canActivate: [permissionGuard, purchaseOrderCreateGuard],
    data: {
      title: 'Nueva orden de compra',
      requiredPath: '/ordenes-compra'
    }
  },
  {
    path: 'ordenes-compra/:id',
    loadComponent: () =>
      import('./purchase-order/purchase-order-form/purchase-order-form.component').then(
        m => m.PurchaseOrderFormComponent
      ),
    canActivate: [permissionGuard],
    data: {
      title: 'Orden de compra',
      requiredPath: '/ordenes-compra'
    }
  },
  {
    path: 'nuevo-envio', 
    loadComponent: () => import('./shipment-create-update/shipment-create-update.component').then(m => m.ShipmentCreateUpdateComponent),
    data: {
      title: 'Envio'
    }
  },
  {
    path: 'modificar-envio/:id', 
    loadComponent: () => import('./shipment-create-update/shipment-create-update.component').then(m => m.ShipmentCreateUpdateComponent),
    data: {
      title: 'Envio'
    }
  },
  {
    path: 'cuentas',
    loadComponent: () => import('./account-cash-movement/component/account-cash-movement.component').then(m => m.AccountCashMovementComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Cuentas',
      requiredPath: '/cuentas'
    }
  },
  {
    path: 'reporte-cuentas',
    loadComponent: () => import('./reports/report-accounts/report-accounts.component').then(m => m.ReportAccountsComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Reporte de Cuentas',
      requiredPath: '/reporte-cuentas',
      requiredRole: 'ADMIN_OR_SUPER_USER'
    }
  },
  {
    path: 'pantalla-cliente',
    loadComponent: () => import('./customer-display-admin/customer-display-admin.component').then(m => m.CustomerDisplayAdminComponent),
    canActivate: [permissionGuard],
    data: {
      title: 'Pantalla para Cliente',
      requiredPath: '/pantalla-cliente',
      requiredRole: 'SUPER_USER'
    }
  }
];
